import _ from 'lodash'

import { DELIVERY_PROJECT_MNG } from '@/api/apiModules'
export default {
  viewType: 'form',
  module: DELIVERY_PROJECT_MNG,
  needFetchFillInfo: false,
  callBackAction: 'CreateProjectSuccessBack',
  params: null,
  formatData(data) {
    data.postsalesIdList = []
    if (data.presalesIdLabel) {
      data.presalesId = data.presalesIdLabel.id
    }

    data.postsalesIdLabelList.forEach(element => {
      data.postsalesIdList.push(element.id)
    })
    return data
  },
  view: {
    title: 'deliveryMng.createBaseDdProject',
    labelPosition: 'right',
    labelWidth: '165px',
    width: '960px',
    content: [
      {
        $id: 'industryId',
        $type: 'radio-button',
        label: 'pocMng.industry',
        $default: null,
        params: {
          unPage: true
        },
        $el: {
          class: 'wsp-custom-edit-industry-disabled',
          disabled: true
        },
        $options: 'projectInfo/industry/list',
        dataType: 'asyn',

        format: function(meta, value) {
          const _options = _.isArray(meta.$options) && meta.$options.length > 0 ? meta.$options : []
          meta.$options = _options
            .filter(item => item.industryCode === 'QY')
            .map(item => {
              return {
                value: item.id,
                label: item.industryName
              }
            })
          if (!value) {
            value = meta.$options[0].value
          }

          return value
        },
        rules: [
          {
            notEmpty: 'pocMng.industryEmpty'
          }
        ]
      },

      {
        $id: 'projectName',
        $type: 'input',
        label: '项目名称',
        $el: { disabled: true },
        rules: [
          {
            notEmpty: '项目名称'
          }
        ],
        $enableWhen: {
          projectName: function(currentValue, data, meta) {
            var cusData = {
              vmData: data
            }

            const merged = Object.assign({}, meta.$el, cusData)
            meta.$el = merged
            return true
          }
        }
      },
      {
        $id: 'customer',
        $type: 'input',
        label: 'pocMng.customer',
        rules: [
          {
            notEmpty: 'pocMng.customer'
          }
        ]
      },

      // {
      //   $id: 'salesIdLabel',
      //   $type: 'sky-relation-option',
      //   label: 'pocMng.sales',
      //   $el: { disabled: false, multiple: false },

      //   actions: {
      //     nativeOn: {
      //       click: 'UmRelationUser'
      //     }
      //   },
      //   rules: [{ notEmpty: { message: 'pocMng.salesEmpty' } }]
      // },
      {
        $id: 'presalesIdLabel',
        $type: 'sky-relation-option',
        label: 'pocMng.presales',
        $el: { disabled: false },
        actions: {
          nativeOn: {
            click: 'UmRelationUser'
          }
        }
        // rules: [{ notEmpty: { message: 'pocMng.presalesEmpty' } }]
      },
      {
        $id: 'salesLeaderLabelList',
        $type: 'sky-relation-option',
        label: '管理者',
        $el: { disabled: false, multiple: true },
        actions: {
          nativeOn: {
            click: 'UmRelationUserList'
          }
        },
        rules: [{ notEmpty: { message: '管理者不能为空' } }]
      },
      {
        $id: 'postsalesIdLabelList',
        $type: 'sky-relation-option',
        label: 'pocMng.postsales',
        $el: { disabled: false, multiple: true },
        actions: {
          nativeOn: {
            click: 'UmRelationUserList'
          }
        },
        rules: [{ notEmpty: { message: 'pocMng.postsalesEmpty' } }]
      },
      {
        $id: 'contractNo',
        $type: 'input',
        label: '合同编号',
        $el: { disabled: true },
        rules: [
          {
            notEmpty: '合同编号'
          }
        ]
      },
      {
        $id: 'startTime',
        $type: 'datePicker',
        $el: {
          type: 'date'
        },
        label: 'pocMng.startTime',
        rules: [
          {
            notEmpty: 'pocMng.startTimeEmpty'
          }
        ]
      },
      {
        // 隐藏字段信息
        $id: 'productName',
        $type: 'sky-form-value',
        label: '部署产品包',
        $el: { disabled: true, defaultValue: 'xxxxxx' }
      },
      {
        // 隐藏字段信息
        $id: 'productList',
        $type: 'sky-delivery-deploy-product',
        label: '项目设备清单'
      }
    ]
  }
}
